import React from 'react'
import { Link } from 'gatsby'

import style from './Endpoints.module.scss'

const Endpoint = ({
  endpoint,
  verb
}) => (
  <Link
    to={ endpoint.urlPath }
    className={style.link}
  >
    <strong data-verb={endpoint.verb}>{ verb }</strong>
    <span>{ endpoint.title }</span>
  </Link>
)

export default Endpoint